import { useCallback } from 'react';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getLoggedInUser } from '@/store/account/selector';
import { computeCustomerIdHash } from '@/api/user';
import { prod } from 'src/config';
import { ChurnkeyConfig } from '@/interfaces/IChurnkey';

export const useChurnkey = () => {
	const loggedInUser = useAppSelector(getLoggedInUser);

	const getChurnkeyConfig = useCallback(
		async (customerId?: string): Promise<ChurnkeyConfig | null> => {
			const customerIdToUse = customerId || loggedInUser?.customerId;
			const churnkeyAppId = import.meta.env.VITE_APP_CHURNKEY_APP_ID;

			if (!customerIdToUse || !churnkeyAppId) {
				return null;
			}

			try {
				const authHash = await computeCustomerIdHash({ customerId: customerIdToUse });

				if (!authHash?.user_hash) {
					return null;
				}

				return {
					customerId: customerIdToUse,
					authHash: authHash.user_hash,
					appId: churnkeyAppId,
					mode: prod ? 'live' : 'test',
					provider: 'stripe',
				};
			} catch (error) {
				console.error(error);
				return null;
			}
		},
		[loggedInUser?.customerId],
	);

	return {
		getChurnkeyConfig,
		loggedInUser,
	};
};
